import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Settings2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../../base/button/button";
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "../../base/dropdown-menu/dropdown-menu";
import { headerTitleOf } from "./column-helpers/column-header";
/**
 * A dropdown component for toggling column visibility in a DataTable.
 * Displays a settings button that opens a menu with checkboxes for each column.
 *
 * @example
 * ```tsx
 * <DataTableViewOptions table={table} />
 * ```
 */ export function DataTableViewOptions({ table, defaultVisibility }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(DropdownMenu, {
        children: [
            /*#__PURE__*/ _jsx(DropdownMenuTrigger, {
                asChild: true,
                children: /*#__PURE__*/ _jsxs(Button, {
                    variant: "outline",
                    size: "small",
                    className: "ml-auto hidden h-8 lg:flex",
                    children: [
                        /*#__PURE__*/ _jsx(Settings2, {
                            className: "mr-2 h-4 w-4"
                        }),
                        t("dataTable.view")
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(DropdownMenuContent, {
                align: "end",
                className: "min-w-[180px] max-w-[300px]",
                children: [
                    /*#__PURE__*/ _jsx(DropdownMenuLabel, {
                        children: t("dataTable.columns")
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                    table.getAllColumns().filter((column)=>column.accessorFn !== undefined && column.getCanHide()).map((column)=>{
                        // The column's label, else its header's title, else its id.
                        const label = column.columnDef.meta?.label || headerTitleOf(column.columnDef.header) || column.id;
                        return /*#__PURE__*/ _jsx(DropdownMenuCheckboxItem, {
                            checked: column.getIsVisible(),
                            onCheckedChange: (value)=>column.toggleVisibility(!!value),
                            children: label
                        }, column.id);
                    }),
                    /*#__PURE__*/ _jsx(DropdownMenuSeparator, {}),
                    /*#__PURE__*/ _jsx(DropdownMenuItem, {
                        onSelect: ()=>table.setColumnVisibility(defaultVisibility ?? {}),
                        children: t("dataTable.resetColumns", {
                            defaultValue: "Reset to default"
                        })
                    })
                ]
            })
        ]
    });
}

//# sourceMappingURL=DataTableViewOptions.js.map